function setError(form,status,error) {
	if (status) {
		form.classList.add(error ? 'is-error_email' : 'is-error_captcha')
		if(error){
			error.classList.remove('hidden')
		}
	} else {
		form.classList.remove(error ? 'is-error_email' : 'is-error_captcha')
		if(error){
			error.classList.add('hidden')
		}
	}
}

function parseEquation(input) {

	// console.log(input);
	// Extract the numbers and operator from the input string
	const match = input.match(/(\d+)\s*([+-])\s*(\d+)\s*=/);
	if (!match) {
		throw new Error('Invalid input');
	}
	const leftOperand = parseInt(match[1], 10);
	const operator = match[2];
	const rightOperand = parseInt(match[3], 10);

	// Calculate the result
	let result;
	if (operator === '+') {
		result = leftOperand + rightOperand;
	} else if (operator === '-') {
		result = leftOperand - rightOperand;
	} else {
		throw new Error('Invalid operator');
	}

	// Check that the result is within range
	if (result < 0 || result > 20) {
		throw new Error('Result out of range');
	}

	return result;
}


export default function formHandler() {
	const 	form = document.getElementById('newsletterForm'),
			emailReg = /\S+@\S+\.\S+/;

	const 	parent = form.closest('.form-wrapper'),
			email = form.querySelector('#email'),
			captcha = form.querySelector('.captcha__field'),
			error = document.querySelector('.form_subscribe__error');


	function checkFields(type){
		if(type === 'email' || type === 'both'){
			if(email.value.trim() === '' || !emailReg.test(email.value.trim())){
				setError(form,true,error);
				return false;
			} else {
				setError(form,false,error);
			}
		}
		if(type === 'captcha' || type === 'both'){
			if(captcha.value.trim() === '' || !(+captcha.value.trim() === parseEquation(captcha.placeholder)) ){
				setError(form,true);
				return false;
			} else {
				setError(form,false);
			}
		}
		return true;
	}

	email.addEventListener('input', ()=>{
		checkFields('email')
	})
	captcha.addEventListener('input', ()=>{
		checkFields('captcha')
	})

	form.addEventListener('submit', function (event) {
		event.preventDefault();
		// console.log(jQuery(this).serializeArray())
		if(checkFields('both')){
			console.log('sending');

			jQuery(this).css({
				opacity: 0.3
			});
			jQuery.post({
				'url': form.dataset.url,
				'data': {
					'action': 'umkey_subscribe_to_news_block_ajax',
					'block_id': parent.id,
					'form_data': jQuery(this).serializeArray()
				}
			}).done(function (data) {
				// console.log(data);
				jQuery(`#${parent.id}`).html(data);
			}).catch(function (e) {
				jQuery(`#${parent.id}`).append('<p style=\'color: red\'>An error occurred, please try later</p>');
			});
			return false;
		}

	})
}
